<article class="tile" (click)="onClick()" [routerLink]="tile.routerLink || null"
         [attr.aria-label]="tile.ariaLabel || tile.label"
         [attr.data-testid]="tile.testId">
  <img class="media" [src]="tile.image" [alt]="tile.label" loading="lazy">
  <div class="label"><span>{{ tile.label }}</span></div>
</article>
